module.exports = __webpack_public_path__ + "img/safetyPlanner_logo_white.e3df4f78.png";